interface Action {
    type: string;
    payload: any;
}

// The initial state of the App
const initialState = {};

function submittingReducer(state: any = initialState, action: Action): any {
    const { type } = action;
    const matches = /(.*)_(CREATE|UPDATE|DELETE|MANAGE|DOWNLOAD|ARCHIVE|EXPORT|ADD|REMOVE|UNSCHEDULE|MERGE|APPROVE|UNAPPROVE|INVITE|GRANT|SAVE|SUBMIT|COMPLETE)_(REQUESTED|SUCCEEDED|FAILED|CANCELED)/.exec(
        type
    );

    // not a submitting action, so we ignore it
    if (!matches) return state;

    const [, requestName, requestType, requestState] = matches;

    return {
        ...state,
        // Store whether a request is happening at the moment or not
        [`${requestName}_${requestType}`]: requestState === 'REQUESTED'
    };
}

export default submittingReducer;
